
function validate(evt,s) {
  var theEvent = evt || window.event;
  var key = theEvent.keyCode || theEvent.which;
  var val = $(s).val().toString();
  key = String.fromCharCode( key );
  if($(s).hasClass('decimalInt') || val.split('.').length > 1) {
    var regex = /[0-9]/;
  } else {
    var regex = /[0-9]|\./;
  }
  if( !regex.test(key) ) {
    theEvent.returnValue = false;
    if(theEvent.preventDefault) theEvent.preventDefault();
  }
}
function fillAddPrice() { // curtains additional price
  var h = Number($('.curtainsHeight').val());  
  var w = Number($('.curtainsWidth').val());  
  var n = Number($('.widthPart').find('[name="widthN"]').val());console.log(n+'n'); 
  var mp = Number($('.productMainPrice').val())/100;
  if($('.inc_height').length) {
    var hx = Number($('.inc_height').val());
  } else {
    var hx = 1.2;
  }
  if($('.inc_width').length) {
    var wx = Number($('.inc_width').val());
  } else {
    var wx = 1.5;
  }
  if(h > 110) {
    if(w > 100) {
      $('.additionalMeasumentPrice').val('NA');
    } else if(w < 50) {
      if(n % 2 == 0) {
        var ap = ((mp + (h - 80) * hx)/2 - mp)*n;      
      } else {
        var ap = ((mp + (h - 80) * hx) * ((n-1)/2+1)) - mp*n;
      }
      $('.additionalMeasumentPrice').val(ap);
    } else {
      var ap = (h - 80) * hx * n;
      $('.additionalMeasumentPrice').val(ap);
    }
  } else if(w > 40) {
      var ap = (w - 40) * wx * n;
      $('.additionalMeasumentPrice').val(ap);
  } else {
    $('.additionalMeasumentPrice').val(0);
  }
  if($('.additionalMeasumentPrice').val() != '') {
    var nap = Number($('.additionalMeasumentPrice').val());
  } else {
    var nap = 0;
  }
  $('.additionalMeasumentPrice').val(nap.toFixed(1));
  
}
function totalPrice() {
  $('.propFullness').val($('[name="widthZ"]:checked').val());
  $('.propPanels').val($('[name="widthN"]').val());
  $('.reviewLiner').text($('.linerOptions').val());
  $('.reviewHanging').text($('.hangingStyle').val());
  $('.reviewSize').text($('.propWidth').val() + 'x' + $('.propHeight').val())
  $('.reviewPanels input').val($('.propPanels').val());
  var mp = Number($('.productMainPrice').val())/100;console.log(mp+'mp');
  var n = Number($('.widthPart').find('[name="widthN"]').val());console.log(n+"n");
  if($('.additionalMeasumentPrice').val() != '') {
    var ap = Number($('.additionalMeasumentPrice').val());console.log(ap+'ap');
  } else {
    var ap = 0;console.log('else ap');
  }
  var lp = Number($('.linerOptions').attr('data-price'));console.log(lp+'lp');
  var hp = Number($('.hangingStyle').attr('data-price'));console.log(hp+'hp');
  var fp = ((mp*n)+ap+lp+hp)*100; 
  fp = Shopify.formatMoney(fp, $('.product_form').data('money-format'));
  $('.reviewPrice, .showPrice').text(fp);
}

function shadeAdditionalPrice(w,h) {
  var inc = Number($('.inc_price').val());
  if(w<100) {
    if(h>80 && w<40) {
      w = 40;
      var ip = ((h * w - 3200)/100) * inc;
    } else if(w>40 && h<80) {
      h = 80;
      var ip = ((h * w - 3200)/100) * inc;
    } else if(w>40 && h>80) {
      var ip = ((h * w - 3200)/100) * inc;
    } else {
      var ip = 0;
    }
    /*if(w>85) {
      ip = ip+50;
    }*/
    var ns = Number($('.noOfShades').val());
    $('.additionalMeasumentPrice').val(ip*ns);
  } else {
    $('.additionalMeasumentPrice').val(0);
  } 
}
function totalPriceShades() {
  $('.reviewSize').text($('.propWidth').val() + 'x' + $('.propHeight').val());
  if($('.additionalMeasumentPrice').val() != '') {
    var ap = Number($('.additionalMeasumentPrice').val());
  } else {
    var ap = 0;
  }
  var mp = Number($('.productMainPrice').val())/100;
  
  var cs = Number($('.propcaseStyle').attr('data-oprice'));
  var cc = Number($('.propcaseColor').attr('data-oprice'));
  var chs = Number($('.propchordSide').attr('data-oprice'));
  var chm = Number($('.propchordMaterial').attr('data-oprice'));
  
  var ns = Number($('.noOfShades').val());
  
  var opp = cs+cc+chs+chm;
  
  var fp = (((mp+opp)*ns)+ap)*100;
  fp = Shopify.formatMoney(fp, $('.product_form').data('money-format'));
  $('.reviewPrice, .showPrice').text(fp);
}
function fillAddPriceShades() {
  
  if($('.inputBoxMeas .selected').length) {
    var selectedMO  = $('.inputBoxMeas .selected').attr('data-step');
    if(selectedMO == 'Inside') {
      var form = $('.insidePart');
      var w = Number(form.find('[name="widthInside"]').val())-0.25;
      var h = Number(form.find('[name="heightInside"]').val())+2;
      shadeAdditionalPrice(w,h);
    } else {
      var form = $('.outsidePart');
      var w = Number(form.find('[name="widthOutside"]').val()); //+(2*Number(form.find('[name="widthOutsideMargin"]').val()));
      var h = Number(form.find('[name="heightOutside"]').val())+2;
      shadeAdditionalPrice(w,h);
    }
  }
  
  if($('.additionalMeasumentPrice').val() != '') {
    var ap = Number($('.additionalMeasumentPrice').val());
  } else {
    var ap = 0;
  }
  var tp = ap;
  $('.additionalMeasumentPrice').val(tp.toFixed(1));
}
$(document).ready(function(){
  
  $('.product-curtains, .product-shades').on('click','.add_to_cart',function(e){
    e.preventDefault();
    var btn = $(this);
    btn.find('.text').text('Adding...');
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    form.find('.error').remove();
    
    var bi = form.find('.builder_id').val();    
    var ap = Number(form.find('.additionalMeasumentPrice').val());
    if(ap==0) {
      form.find('.additionalMeasumentPrice').remove();
    }
    
    var lpfinalval = $('.linerOptions').val();
    var lpfinalpric = $('.linerOptions').attr('data-price');
    if(lpfinalpric != 0) {
      $('.linerOptions').val(lpfinalval + ' ($' + lpfinalpric + ')' );
    }
                                             
    var hanglval = $('.hangingStyle').val();
    var handpric = $('.hangingStyle').attr('data-price');
    if(handpric != 0) {
      $('.hangingStyle').val(hanglval + ' ($' + handpric + ')' );
    }
    var csfinalval = $('.propcaseStyle').val();
    var csfinalpric = $('.propcaseStyle').attr('data-price');
    if(csfinalpric != 0) {
      $('.propcaseStyle').val(csfinalval + ' ($' + csfinalpric + ')' );
    }
    var chmatval = $('.propchordMaterial').val();
    var chmatvalpan = $('.propchordMaterial').attr('data-price');
    if(chmatvalpan != 0) {
      $('.propchordMaterial').val(chmatval + ' ($' + chmatvalpan + ')' );
    }
    
    
    var mpt = form.find('.mainProTitle').val();
    var hasAddOn = false;
    
    var mainQty = form.find('input[name="quantity"]').val();
    var bsprice = Shopify.formatMoney(Number($('.productMainPrice').val())*mainQty, $('.product_form').data('money-format'));
    
    if($('.product-curtains').length) {
      $('<input type="hidden" name="properties[Base Price]" value="'+bsprice+'" >').insertAfter('.propPanels');
    } else {
      $('<input type="hidden" name="properties[Base Price]" value="'+bsprice+'" >').insertAfter('.propShades');
    }
    
    
    if($('.product-curtains').length) {
      var nop = Number($('.noOfPanels').val());        
      $('.divSelectOption').each(function(){
        var vid = $(this).find('.selected').attr('data-vid');
        var vpr = Number($(this).find('.selected').attr('data-price'));
        if(vpr > 0) {
          jQuery.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: { id: vid, quantity: nop, properties: { 'For product': mpt, 'Builder_ID': bi }},
            async: false
          });
          hasAddOn = true;
        }
      });
    }    
    if($('.product-shades').length) {
      var nop = Number($('.noOfShades').val());        
      $('.shadeAddOnPrice').each(function(){
        var vid = $(this).find('input:checked').attr('data-vid');
        var vpr = Number($(this).find('input:checked').attr('data-price'));
        if(vpr > 0) {
          jQuery.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: { id: vid, quantity: nop, properties: { 'For product': mpt, 'Builder_ID': bi }},
            async: false
          });
          hasAddOn = true;
        }
      });
      if(Number($('.propWidth').val()) > 85) {
        jQuery.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: { id: 12652691652659, quantity: 1, properties: { 'For product': mpt, 'Builder_ID': bi }},
          async: false,
          success: function(line_item) {
            $('<input type="hidden" name="properties[Oversize shipping charge]" value="$50">').insertAfter('.propShades');
          }
        });
        hasAddOn = true;
      }
    }
    if(ap > 0) {
      jQuery.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: { id: 8814821179443, quantity: ap*10, properties: { 'For product': mpt, 'Builder_ID': bi }},
        async: false,
        success: function(line_item) {
          $('.additionalMeasumentPrice').val('$' + $('.additionalMeasumentPrice').val());
          jQuery.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: form.serialize(),
            async: false,
            success: function(lpm) {
              window.location = '/cart';
            }
          });
        }
      });
    } else {
      if(!hasAddOn) {
        form.find('.builder_id').remove();
        form.find('.additionalMeasumentPrice').remove();
      }
      $('.additionalMeasumentPrice').val('$' + $('.additionalMeasumentPrice').val());
      jQuery.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: form.serialize(),
        async: false,
        success: function(lpm) {
          window.location = '/cart';
        }
      });
    }   
    
    
  });
  
  
  
  $('.orderSample').on('click', function(e){

    function btnDefault() {
      setTimeout(function(){
        btn.text('Order Free Swatch');
        btn.removeAttr('disabled');
      },1000);
    }

    e.preventDefault();
    
    var btn = $(this);
    var c = 0;
    var x = true;
    var cpi = $('.mainColors input:checked').closest('.swatch-element').index();
    var spi = $('#orderSample span').eq(cpi).attr('data-value');

    btn.attr('disabled','disabled');
    $('.warningMsg').remove();
    jQuery.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      async: false,
      success: function(cart){
        $(cart.items).each(function(i,v){
          if(v.product_type == 'Sample Swatch') {
            c = c + v.quantity;
          }
          if(v.id == spi) {
            x = false;
          }
        });
        //console.log(c);
        if(x) {
          if(c < 5) {
            //btn.text('Adding...');
            jQuery.ajax({
              url: '/cart/update.js',
              type: 'POST',
              dataType: 'json',
              data: "updates["+spi+"]=1",
              async: false,
              success: function(){
                $('.step-1').append('<div class="warningMsg">Your swatch has been added to your cart.</div>');
                btnDefault();
              },
              error: function(XMLHttpRequest, textStatus){
                var data = eval('(' + XMLHttpRequest.responseText + ')');
                if (!!data.message) {
                  $('.step-1').append('<div class="warningMsg">The swatch for this color is currently out of stock. You can still place a curtain order with this color by clicking â€œSelect and Continueâ€ and it will be shipped within 10 days.</div>');
                } else {
                  $('.step-1').append('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
                }
                btnDefault();
              }
            });
          } else {
            $('.step-1').append('<div class="warningMsg">You can order a maximum of 5 free swatches.</div>');
            btnDefault();
          }
        } else {
          $('.step-1').append('<div class="warningMsg">This sample is already in your cart.</div>');
           btnDefault();
        }
        setTimeout(function(){
          $('.warningMsg').fadeOut();
        },4000);
      }      
    });
   
  });
  
  $('.wallColor li').click(function(){
    $('.wallColor li').removeClass('selected');
    $(this).addClass('selected');
    var c = $(this).attr('data-color');
    $('.container.main.content').css('background-color',c);
  });
  
  $('.gotoNext').on('click', function(){
    var btn = $(this);
    btn.closest('.steps').find('.selected').trigger('click');
    btn.closest('.steps').find('input:checked').trigger('change');
    btn.closest('.steps').find('.error').remove();
    
    if($(this).hasClass('checkSelected')) {
      if($(this).closest('.steps').find('.selected').length) {
        var enterhwE = false;
        var o = $(this).closest('.steps').find('.selected').attr('data-sptep');
        $('.optionHelper[data-step="'+o+'"]').find('input').each(function(){
          if($(this).val().trim() == '' || $(this).val().trim() == null) {
            enterhwE = true;
          }
        });
        if(enterhwE) {
          $(this).parent().append('<p class="error">Please enter value in selected option above!</p>');
          return false;
        };
      } else {
        $(this).parent().append('<p class="error">Please select any options above!</p>');
        return false;
      }
    }
    
    var step = Number($(this).attr('data-step'));
    var ostep = step-1;
    
    if($('.product').length) {
      if(ostep==2 && $('input[name="widthN"]').length) {
        $('.totalPanels').text($('input[name="widthN"]').val());
      }

      if(ostep==4) {
        btn.closest('form').find('.warning').remove();
        var cw = Number($('.curtainsWidth').val());
        var ch = Number($('.curtainsHeight').val());
        var pnl = Number($('input[name="widthN"]').val());
        if(ch > 110) {
          if(cw < 50 && pnl % 2 == 1) {
            btn.closest('form').append('<div class="warning"><a href="#" class="closeWarning">X</a> <div class="warningInsode"><h4>A Note on Price Transparency</h4><p>Quick tip: Youâ€™ll get the best value for your money if your curtain is less than 110 inches long <b>or</b> if you order an even number of curtains (you can do so by going back to the width measurements stage and choosing our width calculator).</p><p>Curious to know why? Our bolts of fabric are 110 inches wide. So for a curtain thatâ€™s 50 inches wide and 100 inches long, we cut a 50x110 inch piece of fabric from the bolt. But, if your curtain is 50 inches wide and 120 inches long, we have to cut a 120x110 inch piece and use the fabric sideways, leaving much of the fabric unused. </p> <p>Why do we bother telling you all this? Because we think itâ€™s fun to think of all the ways we can save you money.</p></div></div>');
          }
          if(cw > 50 && cw < 110) {
            if(pnl % 2 == 0) {
              btn.closest('form').append('<div class="warning"><a href="#" class="closeWarning">X</a> <div class="warningInsode"> <h4>A Note on Price Transparency</h4><p>Quick tip: Youâ€™ll get the best value for your money if your curtain is less than 110 inches long or if you order an even number of curtains that are less than 50 inches wide (you can do so by going back to the width measurements stage and choosing our width calculator).</p><p>Curious to know why? Our bolts of fabric are 110 inches wide. So for a curtain thatâ€™s 50 inches wide and 100 inches long, we cut a 50x110 inch piece of fabric from the bolt. But, if your curtain is 50 inches wide and 120 inches long, we have to cut a 120x110 inch piece and use the fabric sideways, leaving much of the fabric unused. </p><p>Why do we bother telling you all this? Because we think itâ€™s fun to think of all the ways we can save you money.</p></div></div>');
            } else {
              btn.closest('form').append('<div class="warning"><a href="#" class="closeWarning">X</a> <div class="warningInsode"> <h4>A Note on Price Transparency</h4><p>Quick tip: Youâ€™ll get the best value for your money if your curtain is less than 110 inches long or if you order an even number of curtains that are less than 50 inches wide (you can do so by going back to the width measurements stage and choosing our width calculator).</p><p>Curious to know why? Our bolts of fabric are 110 inches wide. So for a curtain thatâ€™s 50 inches wide and 100 inches long, we cut a 50x110 inch piece of fabric from the bolt. But, if your curtain is 50 inches wide and 120 inches long, we have to cut a 120x110 inch piece and use the fabric sideways, leaving much of the fabric unused. </p><p>Why do we bother telling you all this? Because we think itâ€™s fun to think of all the ways we can save you money.</p></div></div>');
            }
          }
          if(cw > 110) {
            btn.closest('form').append('<div class="warning"><a href="#" class="closeWarning">X</a> <div class="warningInsode"><p class="">Curtains where width is over 100 inches and length is over 110 inches require some special magic to make. Consider reducing the width or length or shoot us an email and weâ€™ll help place your order.</p></div></div>');
            $('.gotoNext').attr('disabled','disabled');

          }
        }
      }
    }
    

    $('.progressBar ul').removeAttr('class');
    $('.progressBar ul').addClass('step'+step);
    
    if(step > 1) {
      $('.proDescPart').addClass('hidetitle');
    } else {
      $('.proDescPart').removeClass('hidetitle');
    }
    
    if($('.step-'+ostep).find('.required').length) {
      var cinput = $('.step-'+ostep).find('.required');
      if(cinput.val().trim() == '' || cinput.val().trim() == null) {
        cinput.css('border-bottom', '1px solid red');
        return false;
      }
    }
    
    $('.rightWrapper .description, .rightWrapper .productprice_outer').slideUp();
    $('.step-'+ostep).slideUp();
    $('.step-'+step).slideDown();
    
    if($(this).closest('form').hasClass('shadesForm')) {
      fillAddPriceShades();
      totalPriceShades();
    } else {
      fillAddPrice();    
      totalPrice();
      if(ch > 110 && cw > 110) {
        $('.showPrice').text('N/A');
      }
    }
  });
  
  $('.gotoBack').on('click', function(){
    $('.gotoNext').removeAttr('disabled');
    var step = Number($(this).attr('data-step'));
    if(step==1) {
      $('.rightWrapper .description, .rightWrapper .productprice_outer').slideDown();  
    }    
    var nstep = step+1;
    $('.step-'+nstep).slideUp();
    $('.step-'+step).slideDown();
    if(step > 1) {
      $('.proDescPart').addClass('hidetitle');
    } else {
      $('.proDescPart').removeClass('hidetitle');
    }
  });
  $('.openHelper').on('click', function(e){
    e.preventDefault();
    var st = $(this).attr('data-step');
    $('.optionHelper[data-step="'+st+'"]').addClass('Showing');
    $('.optionHelper[data-step="'+st+'"]').find('input[type="text"]').eq(0).trigger('focus');
    $('body').addClass('fixed');
    
    $('.optionHelper[data-step="'+st+'"]').find('.slick-initialized').each(function(){
      var x = $(this).attr('data-slick');
      $('.'+x).slick('refresh');
    });

    if($(this).closest('form').hasClass('shadesForm')) {
      $(this).parent().find('.openHelper').removeClass('selected');
      $(this).addClass('selected');
      $('.propHangPos').val(st);
      $('.reviewHanging').text(st);
    }
    
  });
  $('.closeHelper').on('click', function(e){
    e.preventDefault();
    $(this).closest('.optionHelper').removeClass('Showing');
    $('body').removeClass('fixed');
  });

  $('.curtainsWidth').on('blur', function(){
    $('.inputWidth').text($(this).val());
    $('.propWidth').val($(this).val());
    $(this).removeAttr('style');
    fillAddPrice(); 
    totalPrice();
  });
  
  $('.curtainsHeight').on('blur', function(){
    $('.inputHeight').text($(this).val());
    $('.propHeight').val($(this).val());
    $(this).removeAttr('style');
    fillAddPrice(); 
    totalPrice();
  });
  
  $('.submitWidthOptions').on('click', function(e){
    var form = $('.widthPart')
    form.find('.numInput').removeAttr('style');
    var allOK = true;
    form.find('.numInput').each(function(){
      if($(this).val().trim() == '' || $(this).val().trim() == null) {
        $(this).css('border-bottom', '1px solid red');
        allOK = false;
      }
    });
    if(allOK==false) {
      return false;
    }
    var x = Number(form.find('[name="widthX"]').val());
    var y = Number(form.find('[name="widthY"]').val());
    var z = Number(form.find('[name="widthZ"]:checked').val());
    var n = Number(form.find('[name="widthN"]').val());
    console.log(x,y,z,n);
    var width = (x + 2 * y) * z / n;
    width = Math.ceil(width);
    $('.curtainsWidth').val(width);    
    $('.step-3').hide();
    $('.step-4').show();
    $('.inputWidth').text(width);
    $('.propWidth').val(width);
    $('.totalPanels').text(n);
    $(this).closest('.optionHelper').removeClass('Showing');
    $('body').removeClass('fixed');
    //$('.sizeGuide').hide();
    fillAddPrice(); 
    totalPrice();
    $('.ifWidthCalc').html('<p class="autoAppendMsg">Great! you\'re getting '+n+' curtain(s) with a width of '+width+' inches each. Now, let\'s do the length.</p>');
  });
  
  $('.submitHeightOptions').on('click', function(e){
    var form = $('.heightPart');
    form.find('.numInput').removeAttr('style');
    var allOK = true;
    form.find('.numInput').each(function(){
      if($(this).val().trim() == '' || $(this).val().trim() == null) {
        $(this).css('border-bottom', '1px solid red');
        allOK = false;
      }
    });
    if(allOK==false) {
      return false;
    }
    var hs = $('.hangingStyle').val();
    var x = Number(form.find('[name="heightX"]').val());
    var y = Number(form.find('[name="heightY"]').val());
    //var z = Number(form.find('[name="heightZ"]').val());
    if(hs == "Pleated" || hs == "Ring Top") {
      var height = x + y - 1;
    } else {
      var height = x + y + 1; // +z 
    }
    $('.curtainsHeight').val(height);    
    $('.step-4').hide();
    $('.step-5').show();
    $('.inputHeight').text(height);
    $('.propHeight').val(height);
    $(this).closest('.optionHelper').removeClass('Showing');
    $('body').removeClass('fixed');
    fillAddPrice(); 
    totalPrice();
    //$('.ifHeightCalc').html('<p class="autoAppendMsg">Great! yo\'re curtain(s) with a length of '+height+' inches each. Now, lets select Liner Options:</p>');
  });
  
  $('.divSelectOption > div').on('click', function(e){
    var c = $(this).parent().attr('data-prop');
    $(this).siblings('div').removeClass('selected');
    $(this).addClass('selected');
    $('[data-option="'+c+'"]').text($(this).find('h4').text());
    $('.'+c).val($(this).attr('data-value'));
    var n = Number($('.widthPart').find('[name="widthN"]').val());
    var op = Number($(this).attr('data-price'));
    var byNp = n*op;
    $('.'+c).attr('data-Oprice',op);
    $('.'+c).attr('data-price',byNp);
    fillAddPrice(); 
    totalPrice();
  });

  $('.reviewPanels .ss-icon, .widthPannels .ss-icon').on('click', function(e){

    var input = $(this).parent().find('input');
    var ip = Number(input.val());
    if($(this).hasClass('product-plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      ip = 1;
    }
    input.val(ip);
    if($(this).parent().hasClass('widthPannels')) {
      $('.reviewPanels').find('input').val(ip);
    } else {
      $('.widthPart').find('[name="widthN"]').val(ip);
    }
    
    var lp = Number($('.linerOptions').attr('data-oprice'))*ip;
    var hp = Number($('.hangingStyle').attr('data-oprice'))*ip;
    $('.linerOptions').attr('data-price',lp);
    $('.hangingStyle').attr('data-price',hp);
    
    $('.totalPanels').text(ip);
    setTimeout(function(){
      fillAddPrice(); 
      totalPrice();
    },100);

  });
  
  $('.reviewShades .ss-icon').on('click', function(e){
    
    var input = $(this).parent().find('input');
    var ip = Number(input.val());
    if($(this).hasClass('product-plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      ip = 1;
    }
    input.val(ip);
    
    var cm = Number($('.propchordMaterial').attr('data-oprice'))*ip;
    var cs = Number($('.propcaseStyle').attr('data-oprice'))*ip;
    $('.propchordMaterial').attr('data-price',cm);
    $('.propcaseStyle').attr('data-price',cs);
    
    $('.propShades').val(ip);
    
    setTimeout(function(){
      fillAddPriceShades();
      totalPriceShades();
    },100);
  });
  
  
  $('.curtainsHeight, .curtainsWidth').on('keyup',function(){
    fillAddPrice(); 
    totalPrice();
  });
  
  $('body').on('click','.closeWarning', function(e){
    e.preventDefault();
    $('.warning').hide();
  });
  
  
  $('.submitShadeMasure').on('click', function(e){
    var form = $(this).closest('.optionHelper');
    $('.errMsg').remove();
    $('.gotoNext').removeAttr('disabled');
    form.find('.numInput').removeAttr('style');
    var allOK = true;
    form.find('.numInput').each(function(){
      if($(this).val().trim() == '' || $(this).val().trim() == null) {
        $(this).css('border-bottom', '1px solid red');
        allOK = false;
      }
    });
    if(allOK==false) {
      return false;
    }
    
    if($(this).hasClass('submitInsideOptions')) {
      var sop = 'Inside';
      var w = Number(form.find('[name="widthInside"]').val())-0.25;
      var h = Number(form.find('[name="heightInside"]').val())+2;
    }else {
      var sop = 'Outside';
      var w = Number(form.find('[name="widthOutside"]').val()); //+(2*Number(form.find('[name="widthOutsideMargin"]').val()));
      var h = Number(form.find('[name="heightOutside"]').val())+2;
    }
    $('.inputWidth').text(w);
    $('.inputHeight').text(h);
    $('.propWidth').val(w);
    $('.propHeight').val(h);
    
    if(w>85) {
      $('.shadesForm').find('.warning').remove();
      $('.shadesForm').append('<div class="warning"><a href="#" class="closeWarning">X</a> <div class="warningInsode"><p class=" ">Please note that shades over 85 inches wide incur an oversize shipping charge of $50. Consider breaking up your order into two smaller shades to avoid this charge</p></div></div>'); 
    }
    
    if(w>94) {
      $(this).closest('.helperOptionWrap').append('<p class="errMsg red note">Shades over 94 inches wide require some special magic to make. Please contact us by email and our team will help you with your order!â€</p>');
      $('.gotoNext').attr('disabled','disabled');
      $('.showPrice').text('N/A');
    } else {
      $(this).closest('.optionHelper').removeClass('Showing');
      $('body').removeClass('fixed');
      $('.sizeGuide').hide();
      shadeAdditionalPrice(w,h);
      $('.step-2').hide();
      $('.step-3').show();
      $('.progressBar ul').addClass('step3');
      fillAddPriceShades();
      totalPriceShades();
    }
    
    //$('.shadeSubmitPos').html('<p class="autoAppendMsg">Great! yo\'re getting shade(s) of '+sop+' with a Measurement of '+w+'X'+h+' inches. Now, lets select Liner Options:</p>');
    
  });
  
  
  function updateItem(li,ip,rm) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { line: li, quantity: ip },
      dataType: 'json',
      async: false,
    }).done(function( data ) {
      if(rm==1) {
        window.location = '/cart';
      }
    });
  }
  
  $('.removeItemCart[data-opid]').on('click', function(e){
    e.preventDefault();
    var q = $(this).attr('data-opid');
    $('.'+q).val(0);
    $('#update').trigger('click');
    return false;
  });

  $.getJSON('/cart.js', function(c){
    if(c.items.length == 1 && c.items[0].variant_id == 8814821179443) {
      updateItem(li=1,ip=0,rm=1);
    }
    if(c.items.length == 1 && c.items[0].product_type == 'Customize') {
      updateItem(li=1,ip=0,rm=1);
    }
  });
  

  $('.optionsLists input[type="radio"]').on('change',function(){
    var op = $(this).attr('name');
    var val = $('input[name="'+op+'"]:checked').val();
    var dp = $('input[name="'+op+'"]:checked').attr('data-price');
    $('[data-option="'+op+'"]').text(val);
    var ns = Number($('.noOfShades').val());
    $('[data-prop="'+op+'"]').val(val).attr('data-price',dp*ns);
    $('[data-prop="'+op+'"]').val(val).attr('data-oprice',dp);
    totalPriceShades();
  });
  
  $('.qtyInfo .mark').click(function(){
  	$(this).closest('.qtyInfo').find('.qtyinfodetails').toggleClass('openQty');
  });
  window.onclick = function(e) {
    if (!$(e.target).closest('.qtyInfo').length) {
      $('.qtyinfodetails').removeClass('openQty');
    }
    if ($(e.target).hasClass('popupOverlay')) {
      $('.popupOverlay').fadeOut();
    } 
  }
  
  
  $('.noteDescPopup').on('click', function(){
    $('.forNote').fadeIn();
  });
  
  $('.notewidthPopup').on('click', function(){
    $('.forNotewidth').fadeIn();
  });
  
  $('.cls_popup').on('click', function(){
    $('.popupOverlay').fadeOut();
  });

  
});
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}